// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import * as Yup from "yup";
import { InfoType } from "../../../components/src/CustomInfoDialog.web"
export const configJSON = require("./config");

interface IForgotPasswordPayload {
  email: string;
}

interface IForgotPasswordSuccessResponse {
  message: string;
  reset_token: string;
}

interface IForgotPasswordErrorResponse {
  error: string;
}

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .transform((value) => value?.trim())
    .email("Please enter valid email address")
    .required("Email is required"),
});
// Customizable Area End

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  isLoading: boolean;
  isForgotPassEmailSent: boolean;
  successSentMailEmail: string;
  apiError: string
  isInfoDialog: boolean
  infoType: InfoType
  infoMessage: string
  // Customizable Area End
}

export interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class ForgotPasswordController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  forgotPasswordApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.CountryCodeMessage),
    ];
    this.receive = this.receive.bind(this);

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    this.state = {
      // Customizable Area Start
      isLoading: false,
      isForgotPassEmailSent: false,
      successSentMailEmail: "",
      apiError: "",
      isInfoDialog: false,
      infoType: "success",
      infoMessage: ""
      // Customizable Area End
    };

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.forgotPasswordApiCallId) {
        this.handleForgotMailSentResponse(responseJson);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  openInfoDialog = (infoType: InfoType, infoMessage: string = "") => {
    this.setState({
      isInfoDialog: true,
      infoType,
      infoMessage
    })
  }

  closeInfoDialog = () => {
    this.setState({
      isInfoDialog: false
    })
  }

  handleForgotPasswordEmailSend = (values: IForgotPasswordPayload) => {
    const trimEmail = values.email.trim()
    this.setState({ successSentMailEmail: trimEmail });
    this.forgotPasswordEmailApi({ email: trimEmail });
  };

  handleReSendForgotEmail = () => {
    const httpBody = {
      email: this.state.successSentMailEmail,
    };
    this.forgotPasswordEmailApi(httpBody);
  };

  handleRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  handleContactUsRedirect = () => {
    this.handleRedirection("Contactus");
  };

  forgotPasswordEmailApi = (httpBody: IForgotPasswordPayload) => {
    this.setState({ isLoading: true });
    const header = {
      "Content-Type": configJSON.loginApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.forgotPasswordApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.forgotPasswordApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  handleForgotMailSentResponse = (
    responseJson: IForgotPasswordSuccessResponse | IForgotPasswordErrorResponse
  ) => {
    if("message" in responseJson) {
      if(this.state.isForgotPassEmailSent) {
        this.openInfoDialog("success", responseJson.message)
      }
      this.setState({ isLoading: false, isForgotPassEmailSent: true })
    } else {
      if(this.state.isForgotPassEmailSent) {
        this.openInfoDialog("error", "")
      }
      this.setState({ isLoading: false, apiError: responseJson.error })
    }
  };
  // Customizable Area End
}
